export default "__VITE_ASSET__8631995f__"